import React from 'react';
import { useTranslation } from 'react-i18next';
import './FilterSidebar.css';

function PriceRangeFilter({ minPrice, maxPrice, onChange }) {
  const { t } = useTranslation();
  return (
    <div className="filterGroup">
      <label>{t('search.priceRange')}</label>
      <div className="priceRangeInputs">
        <input
          type="number"
          placeholder={t('search.minPrice')}
          value={minPrice || ''}
          onChange={(e) =>
            onChange(e.target.value ? Number(e.target.value) : '', maxPrice)
          }
          className="filterInput"
          min={0}
        />
        <span className="priceRangeSep">-</span>
        <input
          type="number"
          placeholder={t('search.maxPrice')}
          value={maxPrice || ''}
          onChange={(e) =>
            onChange(minPrice, e.target.value ? Number(e.target.value) : '')
          }
          className="filterInput"
          min={0}
        />
      </div>
    </div>
  );
}

export default PriceRangeFilter;
